import React, { memo } from 'react';
import { Typography, Stack } from 'investira.react.components';
import { formats, validators } from 'investira.sdk';
import { CONSOLIDACAO_TIPO, PLANO_CONTABIL_TIPO } from '@investirapri/financa.js/lib/enums';
import { ORIGEM } from '../../../enums';

/**
 * Renderiza o componente CardFooter.
 *
 * @param {Object} props - Propriedades do componente.
 * @param {*} props.consolidacao - Propriedade `consolidacao` do componente.
 * @param {*} props.atualizado - Propriedade `atualizado` do componente.
 * @param {*} props.origem - Propriedade `origem` do componente.
 * @param {*} props.pc - Propriedade `pc` do componente.
 *
 * @description
 * Este componente realiza as seguintes operacoes:
 * 1. Recebe as propriedades necessarias para compor a interface
 * 2. Organiza os estados e callbacks usados durante a renderizacao
 * 3. Renderiza a experiencia visual do organismo
 *
 * @returns {JSX.Element|null} Elemento renderizado pelo componente.
 */

const CardFooter = memo(props => {
  const { consolidacao, atualizado, origem, pc } = props;

  const xConsolidacaoTipo = Object.values(CONSOLIDACAO_TIPO).find(xItem => xItem.id === consolidacao);

  return (
    <Stack direction="row" justifyContent="space-between">
      <Stack>
        {!validators.isNull(consolidacao) && (
          <Typography variant="caption" color="textSecondary">
            {xConsolidacaoTipo?.descricao}
          </Typography>
        )}
      </Stack>
      <Stack>
        {!validators.isNull(origem) && (
          <Typography variant="caption" color="textSecondary">
            {`Origem ${ORIGEM[origem].descricao}`}
          </Typography>
        )}
        {!validators.isNull(atualizado) && (
          <Typography variant="caption" color="textSecondary">
            {`Atualizado em ${formats.formatDateCustom(atualizado, 'DD/MM/YYYY')}`}
          </Typography>
        )}
        {!validators.isNull(pc) && (
          <Typography variant="caption" color="textSecondary">
            {`Plano Contábil: ${PLANO_CONTABIL_TIPO[pc].descricao}`}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
});

CardFooter.displayName = 'CardFooter';

export default CardFooter;
